import {EditarEnderecoClienteController} from "../clientes/cadastro/editarEnderecoController";

declare var window: any;
import { ControllerBase } from 'controllerBase';
const ko = require('knockout')
import { Paginator } from "paginator";
import {VendedorOrcamentoController} from "./vendedorOrcamentoController";

export const CadastroIndicadorController = ControllerBase.extend({
    name: "CadastroIndicadorController",
    framework: "knockout",
    region: "#cadastro-indicador-container",

    ajax: function () {
        var data = {
            codigoIndicador: (this.codigoIndicador && this.codigoIndicador !== 0) ? this.codigoIndicador : null
        };

        this.novoIndicador = !this.codigoIndicador || this.codigoIndicador === 0;

        return {
            url: "/Orcamento/_CadastroIndicador",
            type: "post",
            cache: false,
            contentType: "application/json",
            data: global.toJSONString(data)
        };
    },

    events: {
        'click #incluir-endereco': "incluirEndereco"
    },

    formConfig: {
        selector: "#form-cadastro-indicador",
        submit: {
            selector: "#salvar-indicador",
            loadingText: "Aguarde...",
            callback: "salvarIndicador",
            type: "model",
            modelType: "js"
        },
        rules: {
            'CpfCnpj': {
                validateCpfCnpj: true
            },
            'Nome': {
                required: true
            },
            'Email': {
                email: true,
                required: true
            },
            'Telefone': {
                required: true
            },
            'Classificacao': {
                required: true
            }
        },
        messages: {
            'CpfCnpj': {
                validateCpfCnpj: "O campo \"CPF / CNPJ\" é inválido."
            },
            'Nome': {
                required: "O campo \"Nome\" é obrigatório."
            },
            'Email': {
                email: "O campo \"E-mail\" é inválido.",
                required: "O campo \"E-mail\" é obrigatório."
            },
            'Telefone': {
                required: "O campo \"Telefone\" é obrigatório."
            },
            'Classificacao': {
                required: "O campo \"Classificação\" é obrigatório."
            }
        },
        ignore: []
    },

    antesBinding: function () {
        this.model.CpfCnpj.subscribe($.proxy(this.cpfCnpjAlterado, this));

        this.select2Vendedores = {
            ajax: {
                url: "/Vendedor/ListarPorNomePessoa",
                type: "post",
                data: function (params) {
                    return { nome: params.term };
                },
                processResults: function (data) {
                    return {
                        results: $.map(data, function (i) {
                            return { id: i.Oid, text: i.NomePessoa };
                        })
                    };
                }
            },
            minimumInputLength: 1
        };

        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },

    renderizacaoCompleta: function () {
        global.applyConditionalMask({
            triggerElement: this.currentRegion.el + ' input[name="Celular"]',
            triggerEvent: "keydown",
            initialMask: "CelularAntigo",
            options: {
                removeMaskOnSubmit: false
            },
            masks: [
                {
                    name: "CelularAntigo",
                    mask: "(99) 9999-9999[9]",
                    initialCondition: function (e) {
                        var value = $(e.target).inputmask("unmaskedvalue");
                        if (value) {
                            value = global.replaceAll(value, "-", "");
                            value = global.replaceAll(value, "(", "");
                            value = global.replaceAll(value, ")", "");
                            value = global.replaceAll(value, " ", "");
                        }
                        return value && value.length <= 10;
                    },
                    condition: function (e) {
                        if (e.which && (e.which == 9 || e.which == 13 || e.which == 17)) {
                            return false;
                        }
                        var value = $(e.target).inputmask("unmaskedvalue");
                        if (value) {
                            value = global.replaceAll(value, "-", "");
                            value = global.replaceAll(value, "(", "");
                            value = global.replaceAll(value, ")", "");
                            value = global.replaceAll(value, " ", "");
                        }
                        return value && value.length < 10;
                    }
                },
                {
                    name: "CelularNovo",
                    mask: "(99) 99999-9999",
                    initialCondition: function (e) {
                        var value = $(e.target).inputmask("unmaskedvalue");
                        if (value) {
                            value = global.replaceAll(value, "-", "");
                            value = global.replaceAll(value, "(", "");
                            value = global.replaceAll(value, ")", "");
                            value = global.replaceAll(value, " ", "");
                        }

                        return value && value.length > 10;
                    },
                    condition: function (e) {
                        if (e.which && (e.which == 9 || e.which == 13 || e.which == 17)) {
                            return false;
                        }
                        var value = $(e.target).inputmask("unmaskedvalue");
                        if (value) {
                            value = global.replaceAll(value, "-", "");
                            value = global.replaceAll(value, "(", "");
                            value = global.replaceAll(value, ")", "");
                            value = global.replaceAll(value, " ", "");
                        }
                        return value && value.length >= 10;
                    }
                }
            ]
        });

        global.applyConditionalMask({
            triggerElement: this.currentRegion.el + ' input[name="Telefone"]',
            triggerEvent: "keydown",
            initialMask: "TelefoneAntigo",
            options: {
                removeMaskOnSubmit: false
            },
            masks: [
                {
                    name: "TelefoneAntigo",
                    mask: "(99) 9999-9999[9]",
                    initialCondition: function (e) {
                        var value = $(e.target).inputmask("unmaskedvalue");
                        if (value) {
                            value = global.replaceAll(value, "-", "");
                            value = global.replaceAll(value, "(", "");
                            value = global.replaceAll(value, ")", "");
                            value = global.replaceAll(value, " ", "");
                        }
                        return value && value.length <= 10;
                    },
                    condition: function (e) {
                        if (e.which && (e.which == 9 || e.which == 13 || e.which == 17)) {
                            return false;
                        }
                        var value = $(e.target).inputmask("unmaskedvalue");
                        if (value) {
                            value = global.replaceAll(value, "-", "");
                            value = global.replaceAll(value, "(", "");
                            value = global.replaceAll(value, ")", "");
                            value = global.replaceAll(value, " ", "");
                        }
                        return value && value.length < 10;
                    }
                },
                {
                    name: "TelefoneNovo",
                    mask: "(99) 99999-9999",
                    initialCondition: function (e) {
                        var value = $(e.target).inputmask("unmaskedvalue");
                        if (value) {
                            value = global.replaceAll(value, "-", "");
                            value = global.replaceAll(value, "(", "");
                            value = global.replaceAll(value, ")", "");
                            value = global.replaceAll(value, " ", "");
                        }

                        return value && value.length > 10;
                    },
                    condition: function (e) {
                        if (e.which && (e.which == 9 || e.which == 13 || e.which == 17)) {
                            return false;
                        }
                        var value = $(e.target).inputmask("unmaskedvalue");
                        if (value) {
                            value = global.replaceAll(value, "-", "");
                            value = global.replaceAll(value, "(", "");
                            value = global.replaceAll(value, ")", "");
                            value = global.replaceAll(value, " ", "");
                        }
                        return value && value.length >= 10;
                    }
                }
            ]
        });

        global.applyConditionalMask({
            triggerElement: this.currentRegion.el + " input[name=\"CpfCnpj\"]",
            triggerEvent: "keydown",
            initialMask: "cpf",
            options: {
                removeMaskOnSubmit: false,
                casing: "upper"
            },
            masks: [
                {
                    name: "cpf",
                    mask: "999.999.999-99[9][9][9]",  // CPF: só numérico
                    initialCondition: function (e) {
                        var value = $(e.target).inputmask("unmaskedvalue");
                        if (value) {
                            value = global.replaceAll(value, ".", "");
                            value = global.replaceAll(value, "-", "");
                        }
                        return value && value.length <= 11;
                    },
                    condition: function (e) {
                        if (e.which &&
                            (e.which == 9 || e.which == 13 || e.which == 17) ||
                            (e.ctrlKey && e.which == 86)) {
                            return false;
                        }
                        var value = $(e.target).inputmask("unmaskedvalue");
                        if (value) {
                            value = global.replaceAll(value, ".", "");
                            value = global.replaceAll(value, "-", "");
                        }
                        return value && value.length <= 11;
                    }
                },
                {
                    name: "cnpj",
                    mask: "AA.AAA.AAA/AAAA-99",
                    initialCondition: function (e) {
                        var value = $(e.target).inputmask("unmaskedvalue");
                        if (value) {
                            value = global.replaceAll(value, ".", "");
                            value = global.replaceAll(value, "-", "");
                            value = global.replaceAll(value, "/", "");
                        }
                        return value && value.length > 11;
                    },
                    condition: function (e) {
                        if (e.which &&
                            (e.which == 9 || e.which == 13 || e.which == 17) ||
                            (e.ctrlKey && e.which == 86)) {
                            return false;
                        }
                        var value = $(e.target).inputmask("unmaskedvalue");
                        if (value) {
                            value = global.replaceAll(value, ".", "");
                            value = global.replaceAll(value, "-", "");
                            value = global.replaceAll(value, "/", "");
                        }
                        return value && value.length > 11;
                    }
                }
            ]
        });

        if (this.model && this.model.classificacoes && this.model.classificacoes() != null && this.model.classificacoes().length === 0)
            global.showWarnMessage("Não existe nenhum classificação para representante");
    },

    cpfCnpjAlterado: function () {

        var self = this;

        var validarCnpjCpfJaCadastrado = self.novo || self.cpfCnpj !== self.model.CpfCnpj() // FNX-4817

        global.ajax({
            url: "/Comum/ObterTipoPessoa",
            type: "get",
            data: {
                numeroCpfCnpj: this.model.CpfCnpj(),
                validarCnpjCpfCadastrado: validarCnpjCpfJaCadastrado  // FNX-4817
            },
            success: function (data) {
                if (!data) {
                    return;
                }

                if (data === "F" || data === "J") {
                    self.model.tipoPessoa(data);
                } else {
                    global.showErrorMessage(data);
                    self.model.CpfCnpj("");
                    return;
                }
            }
        });
    },

    salvarIndicador: function (indicador) {
        var self = this;

        var vendedorRelacionado = $("select[name=VendedorRelacionado] option:selected", this.region.$el).text();
        if (vendedorRelacionado && vendedorRelacionado !== "Selecione") {
            indicador.VendedorRelacionado = vendedorRelacionado;
        } else if (indicador.VendedorRelacionado) {
            indicador.VendedorRelacionado = undefined;
        }

        indicador.DadosAdicionais = ko.toJS(self.model.dadosAdicionais());

        global.ajax({
            url: "/Orcamento/SalvarIndicador",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                indicador: indicador
            }),
            success: function (data) {
                if (!data || data.HasErrors) {
                    return;
                }

                if (self.indicadorCadastradoCallback) {
                    self.indicadorCadastradoCallback(data, self.novoIndicador);
                }

                $("html, body").animate({ scrollTop: $("html, body").offset().top }, 1000);
            }
        });
    },

    afterSubmit: function (data) {
        var self = this;

        if (self.indicadorCadastradoCallback) {
            self.indicadorCadastradoCallback(data, self.novoIndicador);
        }
    },

    incluirEndereco: function (e) {
        if (e) {
            e.preventDefault();
        }

        this.editarEnderecoClienteController = this.showView({
            region: {
                name: "editarEnderecoIndicadorRegion",
                selector: "#editar-endereco-indicador-region"
            },
            controller: {
                type: EditarEnderecoClienteController,
                args: {
                    cliente: this.model,
                    enderecoEditadoCallback: $.proxy(this.enderecoEditado, this),
                    readOnly: this.readOnly,
                    clienteNaoCadastrado: false,
                }
            }
        });
    },

    editarEndereco: function (model) {
        var m = ko.mapping.fromJS(ko.mapping.toJS(model));

        m.editando = true;
        m.index = model.index ? model.index() : undefined;

        this.editarEnderecoClienteController = this.showView({
            region: {
                name: "editarEnderecoIndicadorRegion",
                selector: "#editar-endereco-indicador-region"
            },
            model: m,
            controller: {
                type: EditarEnderecoClienteController,
                args: {
                    cliente: this.model,
                    endereco: model,
                    editando: true,
                    enderecoEditadoCallback: $.proxy(this.enderecoEditado, this),
                    readOnly: this.readOnly,
                    clienteNaoCadastrado: false,
                }
            }
        });
    },

    enderecoEditado: function (endereco) {
        var self = this;

        if (!endereco.editando && endereco.Novo) {
            this.model.Enderecos.push(endereco);

            $.each(this.model.Enderecos(),
                function (i) {
                    self.appendToModel({
                        name: "index",
                        value: i,
                        model: this
                    });
                });
        }

        this.editarEnderecoClienteController.clearRegion();
        this.editarEnderecoClienteController.hide();
        this.show();
    },

    selecionarEndereco: function (model) {
        if (!this.quantidadeEnderecosSelecionados) {
            this.quantidadeEnderecosSelecionados = 0;
        }

        if (model.selecionado) {
            model.selecionado(!model.selecionado());
            this.quantidadeEnderecosSelecionados = this.quantidadeEnderecosSelecionados + (model.selecionado() ? 1 : -1);
        } else {
            this.appendToModel({ name: "selecionado", value: true });
        }

        var permitirEditar = true;

        $.each(this.model.Enderecos(),
            function () {
                if (this.selecionado() && !this.PermitirEditar()) {
                    permitirEditar = false;
                    return false;
                }
                return true;
            });

        this.model.possuiEnderecoSelecionado(this.quantidadeEnderecosSelecionados > 0 && permitirEditar);
    },

    excluirEndereco: function () {
        for (var i = this.model.Enderecos().length - 1; i >= 0; i--) {
            var model = this.model.Enderecos()[i];

            if (model.Novo && model.selecionado && model.selecionado()) {
                this.model.Enderecos.remove(model);
                global.showSuccessMessage("Endereço excluído com sucesso.");
            }
        }

        this.quantidadeEnderecosSelecionados = 0;
        this.model.possuiEnderecoSelecionado(false);
    }
});

(window as any).CadastroIndicadorController = CadastroIndicadorController
